<div class="mode-selection">
  <div class="how-it-works">
    <h2 class="how-title">{{ 'mode.howItWorks' | translate }}</h2>
    <div class="how-steps">
      <div class="how-step">
        <div class="step-number">01</div>
        <div class="step-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="17 8 12 3 7 8"/>
            <line x1="12" y1="3" x2="12" y2="15"/>
          </svg>
        </div>
        <div class="step-label">{{ 'mode.step1Label' | translate }}</div>
        <div class="step-desc">{{ 'mode.step1Desc' | translate }}</div>
      </div>
      <div class="how-arrow" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
        </svg>
      </div>
      <div class="how-step">
        <div class="step-number">02</div>
        <div class="step-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
            <rect x="4" y="4" width="16" height="16" rx="2"/>
            <rect x="9" y="9" width="6" height="6"/>
            <line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/>
            <line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/>
            <line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/>
            <line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/>
          </svg>
        </div>
        <div class="step-label">{{ 'mode.step2Label' | translate }}</div>
        <div class="step-desc">{{ 'mode.step2Desc' | translate }}</div>
      </div>
      <div class="how-arrow" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
        </svg>
      </div>
      <div class="how-step">
        <div class="step-number">03</div>
        <div class="step-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
            <polyline points="22 4 12 14.01 9 11.01"/>
          </svg>
        </div>
        <div class="step-label">{{ 'mode.step3Label' | translate }}</div>
        <div class="step-desc">{{ 'mode.step3Desc' | translate }}</div>
      </div>
      <div class="how-arrow" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
        </svg>
      </div>
      <div class="how-step">
        <div class="step-number">04</div>
        <div class="step-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="8" y1="13" x2="16" y2="13"/>
            <line x1="8" y1="17" x2="13" y2="17"/>
          </svg>
        </div>
        <div class="step-label">{{ 'mode.step4Label' | translate }}</div>
        <div class="step-desc">{{ 'mode.step4Desc' | translate }}</div>
      </div>
    </div>
  </div>

  <div class="mode-cards">
    <div class="mode-card" (click)="selectDigitization()" tabindex="0" role="button"
         [attr.aria-label]="'mode.digitization' | translate"
         (keydown.enter)="selectDigitization()" (keydown.space)="selectDigitization()">
      <div class="mode-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
          <polyline points="10 9 9 9 8 9"/>
        </svg>
      </div>
      <h3 class="mode-card-title">{{ 'mode.digitization' | translate }}</h3>
      <ul class="mode-card-desc-list">
        <li>{{ 'mode.digitizationDesc1' | translate }}</li>
        <li>{{ 'mode.digitizationDesc2' | translate }}</li>
        <li>{{ 'mode.digitizationDesc3' | translate }}</li>
      </ul>
    </div>

    <div class="mode-card" (click)="selectDossierManagement()" tabindex="0" role="button"
         [attr.aria-label]="'mode.dossier' | translate"
         (keydown.enter)="selectDossierManagement()" (keydown.space)="selectDossierManagement()">
      <div class="mode-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
        </svg>
      </div>
      <h3 class="mode-card-title">{{ 'mode.dossier' | translate }}</h3>
      <ul class="mode-card-desc-list">
        <li>{{ 'mode.dossierDesc1' | translate }}</li>
        <li>{{ 'mode.dossierDesc2' | translate }}</li>
        <li>{{ 'mode.dossierDesc3' | translate }}</li>
        <li>{{ 'mode.dossierDesc4' | translate }}</li>
      </ul>
      <div *ngIf="!auth.isAuthenticated" class="mode-register-hint">
        <span class="mode-login-hint" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
          {{ 'mode.registrationRequired' | translate }}
        </span>
      </div>
    </div>
  </div>
</div>
